/**
 * Create Listing — Packages Mixin
 *
 * WooCommerce highlight package helpers and selection.
 *
 * @package Lovasok_Marketplace
 */

export function packagesMixin() {
    return {
        packages: [],
        selectedPackageInfo: '',

        getPackageSortOrder(pkg) {
            const name = (pkg?.name || '').toLowerCase();
            if (name.includes('képes') || name.includes('kepes')) return 10;
            if (name.includes('kiemel') && !name.includes('prémium') && !name.includes('premium')) return 20;
            if (name.includes('prémium') || name.includes('premium')) return 30;
            return 99;
        },

        getPackageType(pkg) {
            const name = (pkg?.name || '').toLowerCase();
            if (name.includes('prémium') || name.includes('premium')) return 'premium';
            if (name.includes('kiemel') && !name.includes('prémium') && !name.includes('premium')) return 'highlight';
            if (name.includes('képes') || name.includes('kepes')) return 'image';
            return 'default';
        },

        getPackageSubtitle(pkg) {
            const type = this.getPackageType(pkg);
            if (type === 'premium')   return '108 FT / NAP';
            if (type === 'highlight') return '42 FT / NAP';
            if (type === 'image')     return '25 FT / NAP';
            return 'KIEMELÉS';
        },

        getPackageBoost(pkg) {
            const type = this.getPackageType(pkg);
            if (type === 'premium')   return '10x több megtekintés';
            if (type === 'highlight') return '8x több megtekintés';
            if (type === 'image')     return '5x megtekintés boost';
            return '';
        },

        getPackageFeatureLines(pkg) {
            const type = this.getPackageType(pkg);
            if (type === 'premium')   return ['10 kép', 'Videó', 'Szín kiemelés', 'Nyitólapon megjelenés'];
            if (type === 'highlight') return ['10 kép', 'Videó', 'Szín kiemelés'];
            if (type === 'image')     return ['3 kép', 'Videó'];
            return [];
        },

        getPackageDisabledFeatureLines(pkg) {
            const type = this.getPackageType(pkg);
            if (type === 'premium')   return [];
            if (type === 'highlight') return ['Nyitólapon megjelenés'];
            if (type === 'image')     return ['Szín kiemelés', 'Nyitólapon megjelenés'];
            return [];
        },

        formatDurationLabel(label) {
            const raw = String(label || '').trim();
            if (!raw) return '';
            const normalized = raw.toLowerCase();
            if (normalized.includes('amig') && normalized.includes('nem') && normalized.includes('adom')) {
                return 'Amíg el nem adom';
            }
            return raw.replace(/-/g, ' ');
        },

        getPackagePriceRange(pkg) {
            if (!pkg?.variations?.length) return '';
            const prices = pkg.variations.map(v => v.price).filter(p => p > 0);
            if (!prices.length) return '';
            const min = Math.min(...prices);
            const max = Math.max(...prices);
            const fmt = n => Number(n).toLocaleString('hu-HU');
            return min === max ? `${fmt(min)} Ft` : `${fmt(min)}–${fmt(max)} Ft`;
        },

        selectPackageVariation(pkg, variation) {
            this.formData.package = variation.id;
            this.selectedPackageInfo = `${pkg.name} — ${variation.duration_name}`;
        },

        selectFreePackage() {
            this.formData.package = 0;
            this.selectedPackageInfo = 'Ingyenes hirdetés';
        },

        isFreePackageSelected() {
            return Number(this.formData.package) === 0;
        },

        selectPackageDefault(pkg) {
            if (pkg?.variations?.length > 0) {
                this.selectPackageVariation(pkg, pkg.variations[0]);
            }
        },

        isPackageActive(pkg) {
            if (!pkg?.variations?.length) return false;
            return pkg.variations.some(v => String(v.id) === String(this.formData.package));
        },
    };
}
